module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"no_video_data":"已登記的視頻不存在。","no_video_reviews":"沒有視頻評論。"}}')
  delete Component.options._Ctor
}
